export enum SavingsSelectedCitiesEnum {
  ABITIBI_70 = "Abitibi 70",
  ADDINGTON_HIGHLANDS = "Addington Highlands",
  ADELAIDE_METCALFE = "Adelaide-Metcalfe",
  ADJALA_TOSORONTIO = "Adjala-Tosorontio",
  ADMASTON_BROMLEY = "Admaston/Bromley",
  AJAX = "Ajax",
  AKWESASNE_PART_59 = "Akwesasne (Part) 59",
  ALFREDAND_PLANTAGENET = "Alfred and Plantagenet",
  ALGOMA_UNORGANIZED_NORTH_PART = "Algoma, Unorganized, North Part",
  ALGONQUIN_HIGHLANDS = "Algonquin Highlands",
  ALNWICK_HALDIMAND = "Alnwick/Haldimand",
  AMARANTH = "Amaranth",
  AMHERSTBURG = "Amherstburg",
  ARMOUR = "Armour",
  ARMSTRONG = "Armstrong",
  ARNPRIOR = "Arnprior",
  AROLAND = "Aroland",
  ARRAN_ELDERSLIE = "Arran-Elderslie",
  ASHFIELD_COLBORNE_WAWANOSH = "Ashfield-Colborne-Wawanosh",
  ASPHODEL_NORWOOD = "Asphodel-Norwood",
  ASSIGINACK = "Assiginack",
  ATHENS = "Athens",
  ATIKOKAN = "Atikokan",
  ATTAWAPISKAT_91_A = "Attawapiskat 91A",
  AUGUSTA = "Augusta",
  AURORA = "Aurora",
  AYLMER = "Aylmer",
  BALDWIN = "Baldwin",
  BANCROFT = "Bancroft",
  BARRIE = "Barrie",
  BAYHAM = "Bayham",
  BEAR_ISLAND_1 = "Bear Island 1",
  BEARSKIN_LAKE = "Bearskin Lake",
  BECKWITH = "Beckwith",
  BELLEVILLE = "Belleville",
  BIG_GRASSY_RIVER_35_G = "Big Grassy River 35G",
  BIG_ISLAND_MAINLAND_93 = "Big Island Mainland 93",
  BILLINGS = "Billings",
  BLACK_RIVER_MATHESON = "Black River-Matheson",
  BLANDFORD_BLENHEIM = "Blandford-Blenheim",
  BLIND_RIVER = "Blind River",
  BLUEWATER = "Bluewater",
  BONFIELD = "Bonfield",
  BONNECHERE_VALLEY = "Bonnechere Valley",
  BRACEBRIDGE = "Bracebridge",
  BRADFORD_WEST_GWILLIMBURY = "Bradford West Gwillimbury",
  BRAMPTON = "Brampton",
  BRANT = "Brant",
  BRANTFORD = "Brantford",
  BRETHOUR = "Brethour",
  BRIGHTON = "Brighton",
  BROCK = "Brock",
  BROCKTON = "Brockton",
  BROCKVILLE = "Brockville",
  BROOKE_ALVINSTON = "Brooke-Alvinston",
  BRUCE_MINES = "Bruce Mines",
  BRUDENELL_LYNDOCHAND_RAGLAN = "Brudenell, Lyndoch and Raglan",
  BURKS_FALLS = "Burk's Falls",
  BURLINGTON = "Burlington",
  BURPEEAND_MILLS = "Burpee and Mills",
  CALEDON = "Caledon",
  CALLANDER = "Callander",
  CALVIN = "Calvin",
  CAMBRIDGE = "Cambridge",
  CARLETON_PLACE = "Carleton Place",
  CARLING = "Carling",
  CARLOW_MAYO = "Carlow/Mayo",
  CASEY = "Casey",
  CASSELMAN = "Casselman",
  CAT_LAKE_63_C = "Cat Lake 63C",
  CAVAN_MONAGHAN = "Cavan Monaghan",
  CENTRAL_ELGIN = "Central Elgin",
  CENTRAL_FRONTENAC = "Central Frontenac",
  CENTRAL_HURON = "Central Huron",
  CENTRAL_MANITOULIN = "Central Manitoulin",
  CENTRE_HASTINGS = "Centre Hastings",
  CENTRE_WELLINGTON = "Centre Wellington",
  CHAMBERLAIN = "Chamberlain",
  CHAMPLAIN = "Champlain",
  CHAPLEAU = "Chapleau",
  CHAPLEAU_74_A = "Chapleau 74A",
  CHAPLEAU_CREE_FOX_LAKE = "Chapleau Cree Fox Lake",
  CHAPPLE = "Chapple",
  CHARLTONAND_DACK = "Charlton and Dack",
  CHATHAM_KENT = "Chatham-Kent",
  CHATSWORTH = "Chatsworth",
  CHIEFS_POINT_NO_28 = "Chief's Point No. 28",
  CHIPPEWASOF_RAMA_FIRST_NATION = "Chippewas of Rama First Nation",
  CHRISTIAN_ISLAND_30_A = "Christian Island 30A",
  CLARENCE_ROCKLAND = "Clarence-Rockland",
  CLARINGTON = "Clarington",
  CLEARVIEW = "Clearview",
  COBALT = "Cobalt",
  COBOURG = "Cobourg",
  COCHRANE = "Cochrane",
  COCHRANE_UNORGANIZED_NORTH_PART = "Cochrane, Unorganized, North Part",
  COCHRANE_UNORGANIZED_SOUTH_EAST_PART = "Cochrane, Unorganized, South East Part",
  COCHRANE_UNORGANIZED_SOUTH_WEST_PART = "Cochrane, Unorganized, South West Part",
  COLEMAN = "Coleman",
  COLLINGWOOD = "Collingwood",
  CONMEE = "Conmee",
  CONSTANCE_LAKE_92 = "Constance Lake 92",
  CORNWALL = "Cornwall",
  COUCHICHING_16_A = "Couchiching 16A",
  CRAMAHE = "Cramahe",
  CURVE_LAKE_FIRST_NATION_35 = "Curve Lake First Nation 35",
  DAWN_EUPHEMIA = "Dawn-Euphemia",
  DAWSON = "Dawson",
  DEEP_RIVER = "Deep River",
  DEER_LAKE = "Deer Lake",
  DESERONTO = "Deseronto",
  DOKIS_9 = "Dokis 9",
  DORION = "Dorion",
  DOURO_DUMMER = "Douro-Dummer",
  DRUMMOND_NORTH_ELMSLEY = "Drummond/North Elmsley",
  DRYDEN = "Dryden",
  DUBREUILVILLE = "Dubreuilville",
  DUCK_LAKE_76_B = "Duck Lake 76B",
  DUTTON_DUNWICH = "Dutton/Dunwich",
  DYSARTETAL = "Dysart et al",
  EAGLE_LAKE_27 = "Eagle Lake 27",
  EAST_FERRIS = "East Ferris",
  EAST_GARAFRAXA = "East Garafraxa",
  EAST_GWILLIMBURY = "East Gwillimbury",
  EAST_HAWKESBURY = "East Hawkesbury",
  EAST_ZORRA_TAVISTOCK = "East Zorra-Tavistock",
  EDWARDSBURGH_CARDINAL = "Edwardsburgh/Cardinal",
  ELIZABETHTOWN_KITLEY = "Elizabethtown-Kitley",
  ELLIOT_LAKE = "Elliot Lake",
  EMO = "Emo",
  ENGLEHART = "Englehart",
  ENGLISH_RIVER_21 = "English River 21",
  ENNISKILLEN = "Enniskillen",
  ERIN = "Erin",
  ESPANOLA = "Espanola",
  ESSA = "Essa",
  ESSEX = "Essex",
  EVANTUREL = "Evanturel",
  FARADAY = "Faraday",
  FAUQUIER_STRICKLAND = "Fauquier-Strickland",
  FORT_ERIE = "Fort Erie",
  FORT_FRANCES = "Fort Frances",
  FRONTOF_YONGE = "Front of Yonge",
  FRONTENAC_ISLANDS = "Frontenac Islands",
  GANANOQUE = "Gananoque",
  GAUTHIER = "Gauthier",
  GEORGIAN_BLUFFS = "Georgian Bluffs",
  GEORGINA = "Georgina",
  GILLIES = "Gillies",
  GODERICH = "Goderich",
  GORDON_BARRIE_ISLAND = "Gordon/Barrie Island",
  GORE_BAY = "Gore Bay",
  GRAND_VALLEY = "Grand Valley",
  GRAVENHURST = "Gravenhurst",
  GREATER_MADAWASKA = "Greater Madawaska",
  GREATER_NAPANEE = "Greater Napanee",
  GREATER_SUDBURY_GRAND_SUDBURY = "Greater Sudbury / Grand Sudbury",
  GREENSTONE = "Greenstone",
  GREY_HIGHLANDS = "Grey Highlands",
  GRIMSBY = "Grimsby",
  GUELPH = "Guelph",
  GUELPH_ERAMOSA = "Guelph/Eramosa",
  HALDIMAND_COUNTY = "Haldimand County",
  HALTON_HILLS = "Halton Hills",
  HAMILTON = "Hamilton",
  HANOVER = "Hanover",
  HARRIS = "Harris",
  HASTINGS_HIGHLANDS = "Hastings Highlands",
  HAVELOCK_BELMONT_METHUEN = "Havelock-Belmont-Methuen",
  HAWKESBURY = "Hawkesbury",
  HEAD_CLARAAND_MARIA = "Head, Clara and Maria",
  HEARST = "Hearst",
  HIGHLANDS_EAST = "Highlands East",
  HILLIARD = "Hilliard",
  HILTON_BEACH = "Hilton Beach",
  HORNEPAYNE = "Hornepayne",
  HORTON = "Horton",
  HOWICK = "Howick",
  HUDSON = "Hudson",
  HUNTSVILLE = "Huntsville",
  HURON_EAST = "Huron East",
  HURON_SHORES = "Huron Shores",
  HURON_KINLOSS = "Huron-Kinloss",
  IGNACE = "Ignace",
  INGERSOLL = "Ingersoll",
  INNISFIL = "Innisfil",
  IROQUOIS_FALLS = "Iroquois Falls",
  JAMES = "James",
  JOHNSON = "Johnson",
  JOLY = "Joly",
  KAPUSKASING = "Kapuskasing",
  KASABONIKA_LAKE = "Kasabonika Lake",
  KAWARTHA_LAKES = "Kawartha Lakes",
  KEARNEY = "Kearney",
  KENORA = "Kenora",
  KENORA_UNORGANIZED = "Kenora, Unorganized",
  KERNS = "Kerns",
  KILLALOE_HAGARTYAND_RICHARDS = "Killaloe, Hagarty and Richards",
  KILLARNEY = "Killarney",
  KINCARDINE = "Kincardine",
  KING = "King",
  KINGSTON = "Kingston",
  KINGSVILLE = "Kingsville",
  KIRKLAND_LAKE = "Kirkland Lake",
  KITCHENER = "Kitchener",
  LA_VALLEE = "La Vallee",
  LA_SALLE = "LaSalle",
  LAKEOF_BAYS = "Lake of Bays",
  LAKESHORE = "Lakeshore",
  LAMBTON_SHORES = "Lambton Shores",
  LANARK_HIGHLANDS = "Lanark Highlands",
  LANSDOWNE_HOUSE = "Lansdowne House",
  LARDER_LAKE = "Larder Lake",
  LATCHFORD = "Latchford",
  LAURENTIAN_HILLS = "Laurentian Hills",
  LAURENTIAN_VALLEY = "Laurentian Valley",
  LEAMINGTON = "Leamington",
  LEEDSANDTHE_THOUSAND_ISLANDS = "Leeds and the Thousand Islands",
  LIMERICK = "Limerick",
  LINCOLN = "Lincoln",
  LONDON = "London",
  LOYALIST = "Loyalist",
  LUCAN_BIDDULPH = "Lucan Biddulph",
  MACDONALD_MEREDITHAND_ABERDEEN_ADDITIONAL = "Macdonald, Meredith and Aberdeen Additional",
  MACHIN = "Machin",
  MADAWASKA_VALLEY = "Madawaska Valley",
  MADOC = "Madoc",
  MAGNETAWAN = "Magnetawan",
  MALAHIDE = "Malahide",
  MANITOUWADGE = "Manitouwadge",
  MAPLETON = "Mapleton",
  MARATHON = "Marathon",
  MARKHAM = "Markham",
  MARKSTAY_WARREN = "Markstay-Warren",
  MARMORAAND_LAKE = "Marmora and Lake",
  MATACHEWAN = "Matachewan",
  MATTAWA = "Mattawa",
  MATTAWAN = "Mattawan",
  MC_DOUGALL = "McDougall",
  MC_GARRY = "McGarry",
  MC_KELLAR = "McKellar",
  MC_MURRICH_MONTEITH = "McMurrich/Monteith",
  MC_NAB_BRAESIDE = "McNab/Braeside",
  MEAFORD = "Meaford",
  MELANCTHON = "Melancthon",
  MERRICKVILLE_WOLFORD = "Merrickville-Wolford",
  MIDDLESEX_CENTRE = "Middlesex Centre",
  MIDLAND = "Midland",
  MILTON = "Milton",
  MINDEN_HILLS = "Minden Hills",
  MINTO = "Minto",
  MISSISSAUGA = "Mississauga",
  MISSISSIPPI_MILLS = "Mississippi Mills",
  MONO = "Mono",
  MONTAGUE = "Montague",
  MOONBEAM = "Moonbeam",
  MOOSONEE = "Moosonee",
  MORLEY = "Morley",
  MORRIS_TURNBERRY = "Morris-Turnberry",
  MULMUR = "Mulmur",
  MUSKOKA_LAKES = "Muskoka Lakes",
  NAIRNAND_HYMAN = "Nairn and Hyman",
  NEEBING = "Neebing",
  NESKANTAGA = "Neskantaga",
  NEW_TECUMSETH = "New Tecumseth",
  NEWBURY = "Newbury",
  NEWMARKET = "Newmarket",
  NIAGARA_FALLS = "Niagara Falls",
  NIAGARAONTHE_LAKE = "Niagara-on-the-Lake",
  NIPIGON = "Nipigon",
  NIPISSING = "Nipissing",
  NORTH_ALGONA_WILBERFORCE = "North Algona Wilberforce",
  NORTH_BAY = "North Bay",
  NORTH_DUMFRIES = "North Dumfries",
  NORTH_DUNDAS = "North Dundas",
  NORTH_FRONTENAC = "North Frontenac",
  NORTH_GLENGARRY = "North Glengarry",
  NORTH_GRENVILLE = "North Grenville",
  NORTH_HURON = "North Huron",
  NORTH_KAWARTHA = "North Kawartha",
  NORTH_MIDDLESEX = "North Middlesex",
  NORTH_PERTH = "North Perth",
  NORTH_STORMONT = "North Stormont",
  NORTHEASTERN_MANITOULINANDTHE_ISLANDS = "Northeastern Manitoulin and the Islands",
  NORTHERN_BRUCE_PENINSULA = "Northern Bruce Peninsula",
  NORWICH = "Norwich",
  OAKVILLE = "Oakville",
  OIL_SPRINGS = "Oil Springs",
  OLIVER_PAIPOONGE = "Oliver Paipoonge",
  OPASATIKA = "Opasatika",
  ORANGEVILLE = "Orangeville",
  ORILLIA = "Orillia",
  ORO_MEDONTE = "Oro-Medonte",
  OSHAWA = "Oshawa",
  OTONABEE_SOUTH_MONAGHAN = "Otonabee-South Monaghan",
  OTTAWA = "Ottawa",
  OWEN_SOUND = "Owen Sound",
  PARRY_SOUND = "Parry Sound",
  PEAWANUCK = "Peawanuck",
  PELEE = "Pelee",
  PELHAM = "Pelham",
  PEMBROKE = "Pembroke",
  PENETANGUISHENE = "Penetanguishene",
  PERRY = "Perry",
  PERTH = "Perth",
  PERTH_EAST = "Perth East",
  PERTH_SOUTH = "Perth South",
  PETAWAWA = "Petawawa",
  PETERBOROUGH = "Peterborough",
  PETROLIA = "Petrolia",
  PIC_MOBERT_NORTH = "Pic Mobert North",
  PIC_MOBERT_SOUTH = "Pic Mobert South",
  PICKERING = "Pickering",
  PICKLE_LAKE = "Pickle Lake",
  PLUMMER_ADDITIONAL = "Plummer Additional",
  PLYMPTON_WYOMING = "Plympton-Wyoming",
  POINT_EDWARD = "Point Edward",
  POPLAR_HILL = "Poplar Hill",
  PORT_COLBORNE = "Port Colborne",
  PORT_HOPE = "Port Hope",
  POWASSAN = "Powassan",
  PRESCOTT = "Prescott",
  PRINCE = "Prince",
  PRINCE_EDWARD_COUNTY = "Prince Edward County",
  PUSLINCH = "Puslinch",
  QUINTE_WEST = "Quinte West",
  RAINY_RIVER = "Rainy River",
  RAINY_RIVER_UNORGANIZED = "Rainy River, Unorganized",
  RAMARA = "Ramara",
  RED_LAKE = "Red Lake",
  RED_ROCK = "Red Rock",
  RENFREW = "Renfrew",
  RICHMOND_HILL = "Richmond Hill",
  RIDEAU_LAKES = "Rideau Lakes",
  RUSSELL = "Russell",
  RYERSON = "Ryerson",
  SABLES_SPANISH_RIVERS = "Sables-Spanish Rivers",
  SARNIA = "Sarnia",
  SAUGEEN_SHORES = "Saugeen Shores",
  SAULT_STE_MARIE = "Sault Ste. Marie",
  SCHREIBER = "Schreiber",
  SCUGOG = "Scugog",
  SEGUIN = "Seguin",
  SELWYN = "Selwyn",
  SEVERN = "Severn",
  SHELBURNE = "Shelburne",
  SHUNIAH = "Shuniah",
  SIOUX_LOOKOUT = "Sioux Lookout",
  SIOUX_NARROWS_NESTOR_FALLS = "Sioux Narrows-Nestor Falls",
  SLATE_FALLS = "Slate Falls",
  SMITHS_FALLS = "Smiths Falls",
  SMOOTH_ROCK_FALLS = "Smooth Rock Falls",
  SOUTH_ALGONQUIN = "South Algonquin",
  SOUTH_BRUCE = "South Bruce",
  SOUTH_BRUCE_PENINSULA = "South Bruce Peninsula",
  SOUTH_DUNDAS = "South Dundas",
  SOUTH_FRONTENAC = "South Frontenac",
  SOUTH_GLENGARRY = "South Glengarry",
  SOUTH_HURON = "South Huron",
  SOUTH_RIVER = "South River",
  SOUTH_STORMONT = "South Stormont",
  SOUTH_WEST_OXFORD = "South-West Oxford",
  SOUTHGATE = "Southgate",
  SOUTHWEST_MIDDLESEX = "Southwest Middlesex",
  SOUTHWOLD = "Southwold",
  SPANISH = "Spanish",
  SPRINGWATER = "Springwater",
  ST_CATHARINES = "St. Catharines",
  ST_CLAIR = "St. Clair",
  ST_JOSEPH = "St. Joseph",
  ST_MARYS = "St. Marys",
  ST_THOMAS = "St. Thomas",
  ST_CHARLES = "St.-Charles",
  STIRLING_RAWDON = "Stirling-Rawdon",
  STONE_MILLS = "Stone Mills",
  STRATFORD = "Stratford",
  STRATHROY_CARADOC = "Strathroy-Caradoc",
  STRONG = "Strong",
  SUNDRIDGE = "Sundridge",
  TAY = "Tay",
  TAY_VALLEY = "Tay Valley",
  TECUMSEH = "Tecumseh",
  TEHKUMMAH = "Tehkummah",
  TEMAGAMI = "Temagami",
  TEMISKAMING_SHORES = "Temiskaming Shores",
  TERRACE_BAY = "Terrace Bay",
  THAMES_CENTRE = "Thames Centre",
  THE_ARCHIPELAGO = "The Archipelago",
  THE_BLUE_MOUNTAINS = "The Blue Mountains",
  THE_NATION_LA_NATION = "The Nation / La Nation",
  THE_NORTH_SHORE = "The North Shore",
  THESSALON = "Thessalon",
  THORNLOE = "Thornloe",
  THOROLD = "Thorold",
  THUNDER_BAY = "Thunder Bay",
  THUNDER_BAY_UNORGANIZED = "Thunder Bay, Unorganized",
  TILLSONBURG = "Tillsonburg",
  TIMMINS = "Timmins",
  TINY = "Tiny",
  TORONTO = "Toronto",
  TRENT_HILLS = "Trent Hills",
  TRENT_LAKES = "Trent Lakes",
  TWEED = "Tweed",
  TYENDINAGA = "Tyendinaga",
  UXBRIDGE = "Uxbridge",
  VAL_RITA_HARTY = "Val Rita-Harty",
  VAUGHAN = "Vaughan",
  WAINFLEET = "Wainfleet",
  WARWICK = "Warwick",
  WASAGA_BEACH = "Wasaga Beach",
  WATERLOO = "Waterloo",
  WAWA = "Wawa",
  WAWAKAPEWIN = "Wawakapewin",
  WEBEQUIE = "Webequie",
  WELLAND = "Welland",
  WELLESLEY = "Wellesley",
  WELLINGTON_NORTH = "Wellington North",
  WEST_ELGIN = "West Elgin",
  WEST_GREY = "West Grey",
  WEST_LINCOLN = "West Lincoln",
  WEST_PERTH = "West Perth",
  WESTPORT = "Westport",
  WHITBY = "Whitby",
  WHITCHURCH_STOUFFVILLE = "Whitchurch-Stouffville",
  WHITE_RIVER = "White River",
  WHITESTONE = "Whitestone",
  WHITEWATER_REGION = "Whitewater Region",
  WILMOT = "Wilmot",
  WINDSOR = "Windsor",
  WOLLASTON = "Wollaston",
  WOODSTOCK = "Woodstock",
  WOOLWICH = "Woolwich",
  ZORRA = "Zorra",
}
